export const VISA_LIST_REQUEST = "VISA_LIST_REQUEST";
export const VISA_LIST_SUCCESS = "VISA_LIST_SUCCESS";
export const VISA_LIST_FAIL = "VISA_LIST_FAIL";

export const VISA_UPDATE_REQUEST = "VISA_UPDATE_REQUEST";
export const VISA_UPDATE_SUCCESS = "VISA_UPDATE_SUCCESS";
export const VISA_UPDATE_FAIL = "VISA_UPDATE_FAIL";
export const VISA_UPDATE_RESET = "VISA_UPDATE_RESET";

export const VISA_PROGRAM_LIST_REQUEST = "VISA_PROGRAM_LIST_REQUEST";
export const VISA_PROGRAM_LIST_SUCCESS = "VISA_PROGRAM_LIST_SUCCESS";
export const VISA_PROGRAM_LIST_FAIL = "VISA_PROGRAM_LIST_FAIL";

export const VISA_PROGRAM_UPDATE_REQUEST = "VISA_PROGRAM_UPDATE_REQUEST";
export const VISA_PROGRAM_UPDATE_SUCCESS = "VISA_PROGRAM_UPDATE_SUCCESS";
export const VISA_PROGRAM_UPDATE_FAIL = "VISA_PROGRAM_UPDATE_FAIL";
export const VISA_PROGRAM_UPDATE_RESET = "VISA_PROGRAM_UPDATE_RESET";

export const VISA_ENTRY_LIST_REQUEST = "VISA_ENTRY_LIST_REQUEST";
export const VISA_ENTRY_LIST_SUCCESS = "VISA_ENTRY_LIST_SUCCESS";
export const VISA_ENTRY_LIST_FAIL = "VISA_ENTRY_LIST_FAIL";

export const VISA_ENTRY_UPDATE_REQUEST = "VISA_ENTRY_UPDATE_REQUEST";
export const VISA_ENTRY_UPDATE_SUCCESS = "VISA_ENTRY_UPDATE_SUCCESS";
export const VISA_ENTRY_UPDATE_FAIL = "VISA_ENTRY_UPDATE_FAIL";
export const VISA_ENTRY_UPDATE_RESET = "VISA_ENTRY_UPDATE_RESET";

export const VISA_NOTICE_LIST_REQUEST = "VISA_NOTICE_LIST_REQUEST";
export const VISA_NOTICE_LIST_SUCCESS = "VISA_NOTICE_LIST_SUCCESS";
export const VISA_NOTICE_LIST_FAIL = "VISA_NOTICE_LIST_FAIL";

export const VISA_NOTICE_UPDATE_REQUEST = "VISA_NOTICE_UPDATE_REQUEST";
export const VISA_NOTICE_UPDATE_SUCCESS = "VISA_NOTICE_UPDATE_SUCCESS";
export const VISA_NOTICE_UPDATE_FAIL = "VISA_NOTICE_UPDATE_FAIL";
export const VISA_NOTICE_UPDATE_RESET = "VISA_NOTICE_UPDATE_RESET";

export const VISA_DOCUMENT_LIST_REQUEST = "VISA_DOCUMENT_LIST_REQUEST";
export const VISA_DOCUMENT_LIST_SUCCESS = "VISA_DOCUMENT_LIST_SUCCESS";
export const VISA_DOCUMENT_LIST_FAIL = "VISA_DOCUMENT_LIST_FAIL";

export const VISA_DOCUMENT_UPDATE_REQUEST = "VISA_DOCUMENT_UPDATE_REQUEST";
export const VISA_DOCUMENT_UPDATE_SUCCESS = "VISA_DOCUMENT_UPDATE_SUCCESS";
export const VISA_DOCUMENT_UPDATE_FAIL = "VISA_DOCUMENT_UPDATE_FAIL";
export const VISA_DOCUMENT_UPDATE_RESET = "VISA_DOCUMENT_UPDATE_RESET";

export const VISA_PROTECTION_LIST_REQUEST = "VISA_PROTECTION_LIST_REQUEST";
export const VISA_PROTECTION_LIST_SUCCESS = "VISA_PROTECTION_LIST_SUCCESS";
export const VISA_PROTECTION_LIST_FAIL = "VISA_PROTECTION_LIST_FAIL";

export const VISA_PROTECTION_UPDATE_REQUEST = "VISA_PROTECTION_UPDATE_REQUEST";
export const VISA_PROTECTION_UPDATE_SUCCESS = "VISA_PROTECTION_UPDATE_SUCCESS";
export const VISA_PROTECTION_UPDATE_FAIL = "VISA_PROTECTION_UPDATE_FAIL";
export const VISA_PROTECTION_UPDATE_RESET = "VISA_PROTECTION_UPDATE_RESET";
